import BaseSplitPage from "../../../components/splitpage";
import { notification } from 'antd';
import { DescriptionText, FlexContainer, H1Text, H2Text, LeftBackButtonText, Spinner } from "../../../design";
import React, { useEffect, useState } from "react";
import getMenuTabs from "../../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../../utils/getUniquePaymentTypes";
import getSecureRedirectionUrl from "../../../utils/getSecureRedirectionUrl";
import { MESSAGES, SWIREPAY_URL, TabNames, QR_STATUSES, NETBANKING_LIST, TANGEDCO_PG, SESSION_TIME, LPG_CUSTOMER } from "../../../appconstants";
import { getInvoiceLinkById, payInvoiceById, BASE_URLS, getSecretValuesById, getCheckoutReconnection, getRecaptchToken, getQrPaymentReconnection, getHealthCheck, getServerEncription, generateClientKeyPair, encryptData, invoiceLinkSplitUp} from "../../../api";
import TransactionModal from "../../../components/modal/transaction";
import SuccessModal from "../../../components/modal/success";
import { AmountDivideByHundred } from "../../../helper";
import Support from "../../../components/support";
import CardPayment from "../../../components/cardpayment/CardPayment";
import currencyFormatter from "../../../utils/currencyformatter";
import PaymentExpandableRows from "../../../components/paymentExpandableRows";
import InvoicePayHeader from "../components/smallscreen/header/InvoicePayHeader";
import InvoicePayFooter from "../components/smallscreen/footer/InvoicePayFootter";
import UpiPayment from "../../../components/upipayment/UpiPayment";
import AchPayment from "../../../components/achPaymentWithPlaid";
import BankPayment from "../../../components/bankpayment/BankPayment";
import NetBanking from "../../../components/netbanking/NetBanking";
import GooglePay from "../../../components/googlePay/GooglePay";
import InstantPayment from "../../../components/instantpayment/InstantPayment";
import UPIIMAGE from "../../../assets/imgs/upiNotification.svg";
import ZipAchPayment from '../../../components/zipAchWithPlaid';
import RapidAchPayment from "../../../components/rapidAchWithPlaid";
import XAchPayment from "../../../components/xAchWithPlaid";
import AutoPayConfirmationModal from "./AutoPayConfirmationModal";
import * as moment from "moment-timezone";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../../redux/customerDetailsInfo";
import RecaptchaModal from "../../../components/recaptcha";

type Props = {
  history: {
    push: Function,
  },
}

const InvoicePay = (props: Props) => {
  const { match: { params: { invoiceLinkId } }, location: { pathname, search } } = props;
  const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
  const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
  const [invoice, setInvoice] = useState(null);
  const [account, setAccount] = useState(null);
  const [errorMessage, setErrorMessage] = useState();
  const [isShowSpinner, setShowSpinner] = useState(false);
  const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
  const [submitBtnText, setSubmitBtnText] = useState(null);
  const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
  const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
  const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${invoiceLinkId}-tap-index`) || 0));
  const [tabName, setTabName] = useState('');
  const [invoiceId, setInvoiceId] = useState('');
  const [banksList, setBanksList] = useState(null);
  const [isTest, setIsTest] = useState(null);
  const [bankTypes, supportedBankTypes] = useState([null]);
  const [gpaySecretValues, setGpaySecretValues] = useState(null);
  const [gpayError, setGpayError] = useState(null);
  const [sitekey, setSitekey] = useState();
  const [isInvoice, setIsInvoice] = useState(false);
  const [processStatus, setProcessStatus] = useState(false);
  const hostName = (window && window.location && window.location.host);
  const [ipAddress, setIpAddress] = useState('');
  const [upiDownTime, setUpiDownTime] = useState(false);
  const [swirepayUS, setSwirepayUS] = useState(false);
  const [googlePayUs, setGooglePayUs] = useState(false);
  const [finalPayableAmount, setFinalPayableAmount] = useState(0);
  const [autoPayConfirmation, setAutoPayConfirmation] = useState({ open: false, confirmation: false, data: null });
  const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${invoiceLinkId}`) || undefined);
  const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
  const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
  const [savedAutoPayMethod, setSavedAutoPayMethod] = useState(null);
  const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
  const [surcharge, setSurcharge] = useState(null);
  const [updatedCardNum, setUpdatedCardNum] = useState('');
  const [optionalCheck, setOptionalCheck] = useState(true);
  const [net, setNet] = useState(null);
  const [feeService, setFeeService] = useState(null);
  const [finalTax, setFinalTax] = useState(null);
  const [totalPayable, setTotalPayable] = useState(null);
  const [caluclation, setCaluclation] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [finalTip, setFinalTip] = useState(null);
  const [subTotal, setSubTotal] = useState(null);
  const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
  const [paymentLinkUpiGlobalRecaptcha, setPaymentLinkUpiGlobalRecaptcha] = useState(null);
  const [paymentLinkInstantPaymentGlobalRecaptcha, setPaymentLinkInstantPaymentGlobalRecaptcha] = useState(null);
  const [manualPlaidPayment, setManualPlaidPayment] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (search) {
      getInvoiceLinkDataWithSearchValue();
    } else {
      getInvoiceLinkDataWithoutSearchValue();
    }
  }, [invoiceLinkId, search]);

  const getData = async () => {
    const response = await fetch('https://api.ipify.org/?format=json');
    const data = await response.json();
    setIpAddress(data.ip);
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if(updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails){
        if (updateCustomerRedux?.customerDetails?.name  && updateCustomerRedux?.customerDetails?.name !== '') {
            setInvoice((prev) => ({...prev, customer: { ...prev.customer, name: updateCustomerRedux.customerDetails.name } }));
        };
        if (updateCustomerRedux?.customerDetails?.email  && updateCustomerRedux?.customerDetails?.email !== '') {
            setInvoice((prev) => ({...prev, customer: { ...prev.customer, email: updateCustomerRedux.customerDetails.email } }));
        };
        if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined'
            && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1'
        ) {
            setInvoice((prev) => ({...prev, customer: { ...prev.customer, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber } }));
        };
        dispatch(setUpdateStatus(false));
    };
  }, [updateCustomerRedux]);

  useEffect(() => {
    if (invoice) {
      setInvoiceId(invoice && invoice.gid)
    }
    if (invoice && invoice.currency && invoice.total && invoice?.invoiceType === "PARTIAL") {
      setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(finalPayableAmount), invoice.currency.name)}`);
    } else if (invoice && invoice.currency && invoice.total) {
      setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(invoice.total), invoice.currency.name)}`);
    }
    getRecaptha();
  }, [invoice, finalPayableAmount]);

  useEffect(() => {
    if (invoice && invoice.currency && invoice.currency.name !== 'INR') { setSelectedTab(0) }
  }, [selectedTab,]);

  const getRecaptha = async () => {
    try {
      const value = await getRecaptchToken();
      if (value) {
        setSitekey(value.siteKey);
        setIsInvoice(value.invoice);
      }
    } catch (reason) {
      error(reason);
    }
  };

  const payInvoiceByCard = async (data) => {
    const customerGid = invoice && invoice.customer ? invoice.customer.gid : null;
    const userAgent = {
      acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
      ip: ipAddress,
      language: window.navigator.language,
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      timeZone: new Date().getTimezoneOffset(),
      browserUserAgent: window.navigator.userAgent
    };
    data.paymentMethod.userAgent = userAgent;
    await chargeById({ paymentMethod: { ...data.paymentMethod, customerGid }, recaptchaToken: data.recaptchaToken, platformType: 'WEB' });
  };

  const chargeByAch = async (data) => {
    const customerGid = invoice && invoice.customer ? invoice.customer.gid : null;
    await chargeById({ paymentMethod: { ...data.paymentMethod, customerGid }, recaptchaToken: data.recaptchaToken, platformType: 'WEB' });
  };

  const chargeByBank = async (data) => {
    const customerGid = invoice && invoice.customer ? invoice.customer.gid : null;
    const { fundingSourceId } = data;
    const paymentMethod = {
      bank: {
        referenceId: fundingSourceId,
      },
      customerGid,
      type: "ACH"
    }
    await chargeById({ paymentMethod, recaptchaToken: data.recaptchaToken, platformType: 'WEB' });
  };

  const chargeByNetBanking = async (data) => {
    const customerGid = invoice && invoice.customer ? invoice.customer.gid : null;
    const { gid } = data;
    const paymentMethod = {
      type: "NET_BANKING",
      customerGid,
      netbanking: {
        swirepayBankGid: gid,
      },
    };
    await chargeById({ paymentMethod: paymentMethod, recaptchaToken: data.recaptchaToken, platformType: 'WEB' });
  };

  const chargeByGooglePay = async (data) => {
    const customerGid = invoice && invoice.customer ? invoice.customer.gid : null;
    const paymentMethod = {
      type: "WALLET",
      subType: "GOOGLE_PAY_US",
      googlePayUS: {
        apiVersionMinor: data.apiVersionMinor,
        apiVersion: data.apiVersion,
        paymentMethodDescription: data.paymentMethodData.description,
        paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
        paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
        paymentMethodType: data.paymentMethodData.type,
        paymentMethodInfo: data.paymentMethodData.info
      },
      customerGid,
    };
    await chargeById({ paymentMethod: paymentMethod });
  };

  const chargeById = async (data, autoPayMethod, recaptchaToken = null) => {
    data.surchargeApplicable = (account?.surchargeType === 'OPTIONAL' && invoice?.surchargeEnabled) ? optionalCheck : (account?.surchargeType !== 'NONE' && invoice?.surchargeEnabled) ? true : false;
    const currentDate = moment.tz(account?.timezone).startOf('day');
    const paymentDueDate = moment(invoice?.paymentDueDate).tz(account?.timezone).startOf('day');
    if(
      invoice?.invoiceType === 'PARTIAL' &&
      invoice?.status === 'ACTIVE' &&
      currentDate.isBefore(paymentDueDate) &&
      !autoPayConfirmation?.confirmation &&
      !autoPayMethod &&
      !invoice?.paidAmount
    ){
      setAutoPayConfirmation({ open: true, data: data, confirmation: false });
      return;
    }
    setTransactionModalOpen(true);
    data['enableAutopay'] = autoPayMethod === 'AUTOPAY' ? true : false;
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          };
          if (encriptedData?.keyId) {
            const value = await payInvoiceById(invoiceLinkId, payload);
            const invoiceLinkGid = value && value.gid;
            const link = value && value.link;
            if (value) {
              const { nextActionUrl, redirectUri, paymentStatus } = value;
              if (paymentStatus && paymentStatus === 'PROCESSING') {
                setProcessStatus(true);
              }
              const timeOut = paymentStatus && paymentStatus === 'REQUIRE_CONFIRMATION' ? SESSION_TIME.MANUAL_PLAID
                              : redirectUri ? SESSION_TIME.REDIRECT_URL
                              : SESSION_TIME.NO_REDIRECT_URL;
              if (nextActionUrl) {
                window.location = nextActionUrl;
                return;
              }
              if (paymentStatus && paymentStatus === 'REQUIRE_CONFIRMATION') {
                setManualPlaidPayment(true);
              }
              setTransactionModalOpen(false);
              setTransactionSuccessModalOpen(true);
              setTimeout(function () {
                const uri = getSecureRedirectionUrl(hostName);
                if (redirectUri) {
                  window.location = `${redirectUri}?sp-payment-link=${invoiceLinkId}`;
                } else if (link) {
                  window.location = `${link}?InvoiceDownload=true`;
                } else if (invoiceLinkGid) {
                  window.location = `${uri}invoice-link/${invoiceLinkGid}?InvoiceDownload=true`;
                }
              }, timeOut);
              sessionStorage.removeItem("stripeRes");
              if (invoiceLinkId) { localStorage.removeItem(`${invoiceLinkId}-tap-index`) }
            }
          }
        }
      }
    } catch (reason) {
      if (reason?.status === 429){
        setSavedPaymentDetails(data);
        setSavedAutoPayMethod(autoPayMethod);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      error(reason);
    }
  };

  const onGlobalCaptchaVerified = async (token) => {
    setRecaptchaModalVisible(false);
    switch (recaptchaPaymentType) {
      case TabNames.UPI:
        setPaymentLinkUpiGlobalRecaptcha(token);
        break;
      case TabNames.INSTANT_PAYMENT:
        setPaymentLinkInstantPaymentGlobalRecaptcha(token);
        break;
      default:
        await chargeById(savedPaymentDetails, token);
    }
    setRecaptchaPaymentType(null);
  }

  const getPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
    try {
      const value = await getCheckoutReconnection(paymentSession, psClientSecret);
      if (value) {
        const { status } = value;
        const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
        if (status === QR_STATUSES.SUCCEEDED) {
          setTransactionSuccessModalOpen(true);
          setTimeout(function () {
            const uri = getSecureRedirectionUrl(hostName);
            if (redirectionUri) {
              window.location = `${redirectionUri}&sp-payment-link=${invoiceLinkId}`;
            } else if (uri) {
              window.location = `${uri}invoice-link/${invoiceId}`;
            }
          }, timeOut);
          if (invoiceLinkId) { localStorage.removeItem(`${invoiceLinkId}-tap-index`) }
        }
      }
    } catch (reason) {
      error(reason);
    }
  };

  const getGooglePayMerchantValues = async (accountGid) => {
    try {
      const values = await getSecretValuesById(accountGid, null);
      setGpaySecretValues(values);
    } catch (error) {
      setGpayError('Missing merchant details. Please contact support');
    }
  };

  const getInvoiceLinkDataWithoutSearchValue = async () => {
    setShowSpinner(true);
    try {
      const value = await getInvoiceLinkById(invoiceLinkId, null);
      if (value) {
        setData(value);
        setSwirepayUS((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('SWIREPAY_US'));
        setGooglePayUs(value && value.account && value.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
        // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
        //   const val = await getHealthCheck();
        //   if (val && val.status !== 'ACTIVE') {
        //     setUpiDownTime(true);
        //     notification.open({
        //         message: '',
        //         description: <img src={UPIIMAGE} alt="" />,
        //       });
        // }
        // }
      }
      if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('WALLET')) {
        getGooglePayMerchantValues(value && value.account && value.account.gid);
      }
    } catch (e) {
      props.history.push(`${pathname}/error`);
    } finally {
      setShowSpinner(false)
    }
  };

  const getInvoiceLinkDataWithSearchValue = async () => {
    const params = new URLSearchParams(search);
    if (!(params.get('ps') || params.get('mp')) || !params.get('secret')) {
      props.history.push(`${pathname}/error`);
      return;
    }
    setShowSpinner(true);
    try {
      const value = await getInvoiceLinkById(invoiceLinkId, search);
      const invoiceLinkGid = value && value.gid;
      const link = value && value.link;
      if (value) {
        const { redirectUri } = value;
        const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
        setData(value);
        setTransactionSuccessModalOpen(true);
        setTimeout(function () {
          const uri = getSecureRedirectionUrl(hostName);
          if (redirectUri) {
            window.location = `${redirectUri}&sp-invoice-link=${invoiceLinkId}`;
          } else if (link) {
            window.location = `${link}`;
          } else if (invoiceLinkGid) {
            window.location = `${uri}invoice-link/${invoiceLinkGid}`;
          }
        }, timeOut);
      }
    } catch (reason) {
      await getInvoiceLinkDataWithoutSearchValue();
      error(reason);
    } finally {
      setShowSpinner(false)
    }
  };

  const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
    try {
      const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
      if (value) {
        const { status, receiptNumber } = value;
        const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
        if (status === QR_STATUSES.SUCCEEDED) {
          if (!redirectionUri) {
            setTransactionSuccessModalOpen(true);
          }
          setTimeout(function () {
            const redirectUrl = redirectionUri ? redirectionUri : SWIREPAY_URL;
            const urlPath = redirectUrl.includes("?");
            if (urlPath) {
              window.location = `${redirectUrl}&sp-invoice-link=${invoiceLinkId}`;
            } else if (!urlPath) {
              window.location = `${redirectUrl}?sp-invoice-link=${invoiceLinkId}`;
            }
          }, timeOut);
          if (invoiceLinkId) { localStorage.removeItem(`${invoiceLinkId}-tap-index`) }
        }
      }
    } catch (reason) {
      error(reason);
    }
  };

  const calculateFinalPayableAmount = (invoice) => {
    if (!invoice || invoice?.invoiceType !== "PARTIAL") return;
    if (invoice.paidAmount === null) {
      setFinalPayableAmount(invoice.invoiceTermsAndConditions?.initialAmount);
    } else {
      setFinalPayableAmount(invoice.total - (invoice.paidAmount ?? 0));
    }
  };

  const getSplitUp = async (metaGid, tabName, cardNum, val) => {
    const params = {
      paymentType: (tabName !== 'CARD' && !cardNum) ? tabName : (cardNum ? 'CARD' : ''),
      cardNumber: tabName === 'CARD' ? cardNum : '',
      surchargeApplicable: (invoice?.surchargeEnabled && account?.surchargeType && account?.surchargeType !== 'NONE') ? true : false,
    };
    if (val === true || val === false) {
      setOptionalCheck(val)
      params.surchargeApplicable = val;
    }

    try {
      const value = await invoiceLinkSplitUp(metaGid, params);
      setNet(value.invoiceAmount);
      setTotalPayable(value.totalPayable);
      setCaluclation(value);
      setSubTotal(value.invoiceAmount);
      setSurcharge(value.surchargeAmount);
    } catch (reason) {
      error(reason);
    }
  }

  const updateSurcharge = (val) => {
    getSplitUp(invoiceLinkId, localStorage.getItem(`${invoiceLinkId}-tab-name`) ? localStorage.getItem(`${invoiceLinkId}-tab-name`) : 0, updatedCardNum, val);
  }

  const getCardNum = (cardNum) => {
    setUpdatedCardNum(cardNum);
    getSplitUp(invoiceLinkId, localStorage.getItem(`${invoiceLinkId}-tab-name`) ? localStorage.getItem(`${invoiceLinkId}-tab-name`) : 0, cardNum);
  }

  const setData = data => {
    if (data) {
      setInvoice(data.invoice);
      setAccount(data.account);
      calculateFinalPayableAmount(data.invoice);
      if (data && data.account && data.account.gid) {
        if (TANGEDCO_PG === data.account.gid) {
          if (data.account.paymentTypeOrder) {
            setPaymentTypeOrder([{ category: 'CARD' }]);
          } else setSupportedPaymentTypes(['CARD']);
        } else if (TANGEDCO_PG !== data.account.gid) {
          if (data.account.paymentTypeOrder) {
            const paymentMethod = getUniquePaymentTypes(data?.invoice?.paymentMethodType?.length > 0 ? data?.invoice?.paymentMethodType : data?.account?.supportedPaymentTypes);
            const paymentOrders = data && data.account && data.account.paymentTypeOrder;
            const filterPaymentOrder = paymentOrders.filter((order) => paymentMethod.includes(order.category));
            const wallet = paymentOrders.filter((item) => item.category === 'WALLET');  
            let newfilterPaymentOrder;
            if (data.account && paymentMethod.includes('WALLET')) {
              setPaymentTypeOrder(filterPaymentOrder);
            } if (data.account 
              && (data.account.supportedPaymentTypes.includes('GOOGLE_PAY_US') || data.account.supportedPaymentTypes.includes('SWIREPAY_US')) 
              && wallet && wallet.length > 0) {
              const googlePay = {
                order: 4,
                category: "WALLET",                  
              }
              filterPaymentOrder.push(googlePay);
              setPaymentTypeOrder(filterPaymentOrder);
              setPaymentTypeOrder(filterPaymentOrder);
            } else {
              newfilterPaymentOrder = filterPaymentOrder.filter(info => info.category !== 'WALLET');
              setPaymentTypeOrder(newfilterPaymentOrder);
            }
          } else {
            setSupportedPaymentTypes(data && data.account && data.account.supportedPaymentTypes);
          }
        }
      }
      if (data.account && data.account.portal) {
        const portal = data.account.portal.test;
        setIsTest(portal);
        supportedBankTypes(data.account.supportedPaymentTypes);
        if (portal) {
          const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
          setBanksList(supportedBanks);
        } else {
          const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
          setBanksList(supportedBanks);
        }
      }
      setBackButtonUrl(data.redirectUri || SWIREPAY_URL);
    }
  };

  const error = reason => {
    if (!reason) return;
    setErrorMessage(null);
    const { data: { message, messageCode }, status } = reason;
    if (messageCode === 5102) {
      props.history.push(`${pathname}/error`);
      return;
    }
    setErrorMessage(message);
    if (status === 400) {
      setErrorMessage(reason?.data?.exceptionReason || message);
    } else if (status === 500) {
      setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
    }
    setTransactionModalOpen(false);
    const errorEl = document.getElementById("error");
    if (null !== errorEl) { errorEl.scrollIntoView(); }
  };

  const payInvoiceByUPI = async (data) => {
    const { paymentMethod, recaptchaToken } = data;
    const customerGid = invoice && invoice.customer ? invoice.customer.gid : null;
    await chargeById({ paymentMethod: { ...paymentMethod, customerGid }, recaptchaToken: recaptchaToken, platformType: 'WEB', address: null });
  };

  const chargeByInstantPay = async (data) => {
    const { walletAlias, recaptchaToken } = data;
    const paymentMethod = {
      type: "INSTANT_PAYMENT",
      instantPayment: {
        alias: walletAlias,
        type: "ALIAS",
      },
    };
    const customerGid = invoice && invoice.customer ? invoice.customer.gid : null;
    await chargeById({ paymentMethod: { ...paymentMethod, customerGid }, recaptchaToken: recaptchaToken, platformType: 'WEB', address: null });
  };

  const chargeBySwirepayUS = async (data) => {
    const { walletAlias, recaptchaToken } = data;
    const paymentMethod = {
      type: "WALLET",
      subType: "SWIREPAY_US",
      swirepayUS: {
          alias: walletAlias,
          type: "ALIAS",
      },
    };
    const customerGid = invoice && invoice.customer ? invoice.customer.gid : null;
    await chargeById({ paymentMethod: { ...paymentMethod, customerGid }, recaptchaToken: recaptchaToken, platformType: 'WEB', address: null });
  };


  const uniquePaymentTypes = (invoice?.paymentMethodType?.length > 0 ? getUniquePaymentTypes(invoice?.paymentMethodType) : (paymentTypeOrder ? paymentTypeOrder.map((res) => res ? res.category : null) : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : ''));
  if(uniquePaymentTypes.includes('WALLET')) {
    if (swirepayUS) {
        uniquePaymentTypes.push('SWIREPAY_US');
    }
    if (!googlePayUs) {
        const index = uniquePaymentTypes.indexOf('WALLET');
        if (index > -1) {
            uniquePaymentTypes.splice(index, 1);  // Removes the 'WALLET' from the array
        }
    } 
}
  const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
    let children;
    let id;
    if (name === TabNames.ACH_LEGACY) {
      children = <AchPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={chargeByAch}
        preFillCustomer={invoice && invoice.customer}
        customerDisabled={true}
        headerText={"Pay With ACH"}
        buttonText={submitBtnText}
        customerValidation={false}
        isCaptchaEnabled={isInvoice}
        sitekey={sitekey}
        isInvoice={isInvoice}
        isBillingAdressRequired={(account && account.collectBillingAddress)}
        alpha2={invoice && invoice.currency && invoice.currency.countryAlpha2}
        plaidPublicToken={plaidPublicToken}
        setPlaidPublicToken={setPlaidPublicToken}
        accountGid={account?.gid}
        paymentLinkId={invoiceLinkId}
      />
      id = name;
    } else if (name === TabNames.CARD) {
      children = <CardPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={true}
        validateInvoice={true}
        submit={payInvoiceByCard}
        preFillCustomer={invoice && invoice.customer}
        headerText={null}
        buttonText={totalPayable ? `PAY ${currencyFormatter(AmountDivideByHundred(totalPayable), invoice.currency.name)}` : submitBtnText}
        isZipCodeRequired={(account && account.collectCustomerAddress)}
        isBillingAdressRequired={(account && account.collectBillingAddress)}
        requiredPhone={false}
        customerValidation={false}
        isCaptchaEnabled={isInvoice}
        sitekey={sitekey}
        isInvoice={isInvoice}
        tabName={tabName}
        alpha2={invoice && invoice.currency && invoice.currency.countryAlpha2}
        paymentTypes={(account && account.currency && account.currency.countryAlpha2)}
        surcharge={surcharge}
        surchargeType={account?.surchargeType}
        surchargeEnabled={invoice?.surchargeEnabled}
        getCardNum={getCardNum}
        updateSurcharge={updateSurcharge}
        tip={finalTip}
        amount={net}
        serviceFeeVal={feeService}
        prefix={invoice && invoice.currency && invoice.currency.prefix}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
      />
      id = name;
    } else if (name === TabNames.ACH) {
      children = <BankPayment
        errorMsg={errorMessage}
        errorHeader={"Error occurred while processing the payment method."}
        customerDisabled={false}
        submit={chargeByBank}
        preFillCustomer={invoice}
        headerText={"Pay With Bank Transfer"}
        buttonText={submitBtnText}
        iavUrl={`${BASE_URLS.INVOICE_LINK}/${invoiceLinkId}`}
        customerValidation={true}
        requiredPhone={false}
        isCaptchaEnabled={isInvoice}
        sitekey={sitekey}
        isInvoice={isInvoice}
        invoiceGid={invoice && invoice.customer && invoice.customer.gid}
        accountId={account && account.gid}
        publicKey={account && account.usPublicKey}
        alpha2={invoice && invoice.currency && invoice.currency.countryAlpha2}
      />
      id = name;
    } else if (name === TabNames.NET_BANKING) {
      children = <NetBanking
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={chargeByNetBanking}
        headerText={"PAY WITH NET BANKING"}
        cancelButtonText={"Decline"}
        buttonText={submitBtnText}
        customerValidation={true}
        banksList={banksList}
        bankTypes={bankTypes}
        isTest={isTest || true}
        isCaptchaEnabled={isInvoice}
        sitekey={sitekey}
        isInvoice={isInvoice}
        alpha2={invoice && invoice.currency && invoice.currency.countryAlpha2}
      />
      id = name;
    } else if (name === TabNames.UPI) {
      children = <UpiPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={true}
        submit={payInvoiceByUPI}
        preFillCustomer={invoice && invoice.customer}
        currentCustomerGid={invoice && invoice.customer && invoice.customer.gid}
        headerText={null}
        buttonText={submitBtnText}
        customerValidation={false}
        hideQr={false}
        getPaymentById={getPaymentById}
        isCaptchaEnabled={isInvoice}
        sitekey={sitekey}
        isInvoice={isInvoice}
        invoicePay={true}
        upiUrl={invoiceLinkId}
        alpha2={invoice && invoice.currency && invoice.currency.countryAlpha2}
        supportedPaymentTypes={invoice && invoice.account && invoice.account.supportedPaymentTypes}
        setRecaptchaModalVisible={setRecaptchaModalVisible}
        setSavedPaymentDetails={setSavedPaymentDetails}
        savedPaymentDetails={savedPaymentDetails}
        globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
        setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
        setRecaptchaPaymentType={setRecaptchaPaymentType}
      />
      id = name;
    } else if (name === TabNames.GOOGLE_PAY_US) {
      children = <GooglePay
        headerText={"PAY WITH GOOGLE PAY"}
        payment={invoice}
        chargeByGooglePay={chargeByGooglePay}
        gpaySecretValues={gpaySecretValues}
        gpayError={gpayError}
        errorMsg={errorMessage}
        errorHeader={null}
      />
    } else if (name === TabNames.WALLET) {
      children = <GooglePay
        headerText={"PAY WITH GOOGLE PAY"}
        payment={invoice}
        chargeByGooglePay={chargeByGooglePay}
        gpaySecretValues={gpaySecretValues}
        gpayError={gpayError}
        errorMsg={errorMessage}
        errorHeader={null}
      />
      id = name;
    } else if (name === TabNames.INSTANT_PAYMENT) {
      children = <InstantPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={chargeByInstantPay}
        customerDisabled={true}
        headerText={null}
        buttonText={submitBtnText}
        hideQr={true}
        getPaymentById={getQrPaymentById}
        showWhatsAppNotify={false}
        upiUrl={`${BASE_URLS.INVOICE_LINK}/${invoiceLinkId}`}
        customerValidation={true}
        cancelButtonText={"Decline"}
        isCaptchaEnabled={isInvoice}
        sitekey={sitekey}
        isInvoice={isInvoice}
        alpha2={invoice && invoice.currency && invoice.currency.countryAlpha2}
        setRecaptchaModalVisible={setRecaptchaModalVisible}
        setSavedPaymentDetails={setSavedPaymentDetails}
        savedPaymentDetails={savedPaymentDetails}
        globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
        setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
        setRecaptchaPaymentType={setRecaptchaPaymentType}
      />
      id = name;
    } else if (name === TabNames.SWIREPAY_US) {
      children = <InstantPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        invoicePay={true}
        submit={chargeBySwirepayUS}
        customerDisabled={true}
        headerText={null}
        buttonText={submitBtnText}
        hideQr={false}
        getPaymentById={getQrPaymentById}
        showWhatsAppNotify={false}
        upiUrl={`${BASE_URLS.INVOICE_LINK}/${invoiceLinkId}`}
        customerValidation={true}
        cancelButtonText={"Decline"}
        isCaptchaEnabled={isInvoice}
        sitekey={sitekey}
        isInvoice={isInvoice}
        alpha2={invoice && invoice.currency && invoice.currency.countryAlpha2}
        swirepayUS={swirepayUS}
        invoiceLinkGid={invoiceLinkId}
        currentCustomerGid={invoice && invoice.customer ? invoice.customer.gid : null}
        setRecaptchaModalVisible={setRecaptchaModalVisible}
        setSavedPaymentDetails={setSavedPaymentDetails}
        savedPaymentDetails={savedPaymentDetails}
        globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
        setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
        setRecaptchaPaymentType={setRecaptchaPaymentType}
      />
      id = name;
    } else if (name === TabNames.ZIP_ACH) {
      children = <ZipAchPayment
      errorMsg={errorMessage}
      errorHeader={null}
      customerReadOnly={false}
      submit={chargeByAch}
      preFillCustomer={invoice && invoice.customer}
      customerDisabled={true}
      headerText={"Pay With ZIP ACH"}
      buttonText={submitBtnText}
      customerValidation={false}
      isCaptchaEnabled={isInvoice}
      sitekey={sitekey}
      isInvoice={isInvoice}
      isBillingAdressRequired={(account && account.collectBillingAddress)}
      alpha2={invoice && invoice.currency && invoice.currency.countryAlpha2}
      plaidPublicToken={plaidPublicToken}
      setPlaidPublicToken={setPlaidPublicToken}
      paymentLinkId={invoiceLinkId}
      accountGid={account?.gid}
      />
      id = name;
  } else if (name === TabNames.RAPID_ACH) {
      children = <RapidAchPayment
      errorMsg={errorMessage}
      errorHeader={null}
      customerReadOnly={false}
      submit={chargeByAch}
      preFillCustomer={invoice && invoice.customer}
      customerDisabled={true}
      headerText={"Pay With RAPID ACH"}
      buttonText={submitBtnText}
      customerValidation={false}
      isCaptchaEnabled={isInvoice}
      sitekey={sitekey}
      isInvoice={isInvoice}
      isBillingAdressRequired={(account && account.collectBillingAddress)}
      alpha2={invoice && invoice.currency && invoice.currency.countryAlpha2}
      plaidPublicToken={plaidPublicToken}
      setPlaidPublicToken={setPlaidPublicToken}
      paymentLinkId={invoiceLinkId}
      accountGid={account?.gid}
      />
      id = name;
  } else if (name === TabNames.X_ACH) {
      children = <XAchPayment
      errorMsg={errorMessage}
      errorHeader={null}
      customerReadOnly={false}
      submit={chargeByAch}
      preFillCustomer={invoice && invoice.customer}
      customerDisabled={true}
      headerText={"Pay With X ACH"}
      buttonText={submitBtnText}
      customerValidation={false}
      isCaptchaEnabled={isInvoice}
      sitekey={sitekey}
      isInvoice={isInvoice}
      isBillingAdressRequired={(account && account.collectBillingAddress)}
      alpha2={invoice && invoice.currency && invoice.currency.countryAlpha2}
      plaidPublicToken={plaidPublicToken}
      setPlaidPublicToken={setPlaidPublicToken}
      paymentLinkId={invoiceLinkId}
      accountGid={account?.gid}
      />
      id = name;
  } else {
      children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
    }
    panel.push({ children, id });
    return panel;
  }, []) : [
    {
      children: <CardPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={true}
        validateInvoice={true}
        submit={payInvoiceByCard}
        preFillCustomer={invoice && invoice.customer}
        headerText={null}
        buttonText={totalPayable ? `PAY ${currencyFormatter(AmountDivideByHundred(totalPayable), invoice.currency.name)}` : submitBtnText}
        isZipCodeRequired={(account && account.collectCustomerAddress)}
        isBillingAdressRequired={(account && account.collectBillingAddress)}
        requiredPhone={false}
        customerValidation={false}
        isCaptchaEnabled={isInvoice}
        sitekey={sitekey}
        tabName={tabName}
        alpha2={invoice && invoice.currency && invoice.currency.countryAlpha2}
        paymentTypes={(account && account.currency && account.currency.countryAlpha2)}
        surcharge={surcharge}
        surchargeType={account?.surchargeType}
        surchargeEnabled={invoice?.surchargeEnabled}
        getCardNum={getCardNum}
        updateSurcharge={updateSurcharge}
        tip={finalTip}
        amount={net}
        serviceFeeVal={feeService}
        prefix={invoice && invoice.currency && invoice.currency.prefix}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
      />,
      id: 'CARD'
    }
  ];

  useEffect(() => {
    setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
  }, [selectedTab, uniquePaymentTypes]);

  return (
    <BaseSplitPage
      errorHeader={null}
      errorMsg={errorMessage}
      left={
      <>
        <FlexContainer
          flexDirection="column"
          position="relative"
          display="block"
          height="100%"
        >
          <div>
            <LeftBackButtonText
              onClick={() => { props.history.push(`/invoice-link/${invoiceLinkId}`); }}
            >Back</LeftBackButtonText>
            <H1Text>
              PAY INVOICE
            </H1Text>
            <div hidden={!(invoice && invoice.description)}>
              <H2Text>
                Payment For
              </H2Text>
              <DescriptionText>
                {invoice && invoice.description}
              </DescriptionText>
            </div>
            <div hidden={!(invoice && invoice.total)}>
              <H2Text>
                {invoice && invoice?.invoiceType === "PARTIAL" ? "Partial Payment" : "Amount Payable"}
              </H2Text>
              {invoice && invoice?.invoiceType !== "PARTIAL" &&
                <DescriptionText fontSize="24px">
                  {invoice && invoice.currency && currencyFormatter(AmountDivideByHundred(invoice.total), invoice.currency.name)}
                </DescriptionText>
              }
              {invoice && invoice?.invoiceType === "PARTIAL" &&
                <DescriptionText fontSize="24px">
                  {invoice.currency && currencyFormatter(AmountDivideByHundred(finalPayableAmount), invoice.currency.name)}
                </DescriptionText>
              }
            </div>
          </div>
          <div style={{ position: "sticky", top: "85%" }}>
            <Support email={account && account.support && account.support.email}
              whiteLabel={account && account.whiteLabel}
              phone={account && account.support && account.support.phone} />
          </div>
        </FlexContainer>
      </>
    } right={
      <>
        <InvoicePayHeader
          invoice={invoice}
          finalPayableAmount={finalPayableAmount}
          cancelUrlLink={`/invoice-link/${invoiceLinkId}`}
        />
        <PaymentExpandableRows
          name={invoiceLinkId}
          id={invoiceLinkId}
          paymentTypes={(account && account.currency && account.currency.countryAlpha2)}
          tabs={uniquePaymentTypes}
          tabPanels={tabPanels}
          defaultSelectedTab={0}
          onSelect={data => setSelectedTab(data)}
          tabName={tabName}
          upiDown={upiDownTime}
          accountGid={account?.gid}
        />
        <InvoicePayFooter support={account && account.support}
          whiteLabel={account && account.whiteLabel} />
         <RecaptchaModal
          visible={recaptchaModalVisible}
          onVerified={onGlobalCaptchaVerified}
        />
        <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
        <SuccessModal isOpen={isTransactionSuccessModalOpen} processing={processStatus} autopayMessage={autoPayConfirmation?.confirmation} manualPlaidPayment={manualPlaidPayment} />
        <Spinner isOpen={isShowSpinner} />
        <AutoPayConfirmationModal
          autoPayConfirmation={autoPayConfirmation}
          setAutoPayConfirmation={setAutoPayConfirmation}
          chargeById={chargeById}
          partialPaymentDetails={invoice?.invoiceTermsAndConditions}
          paymentDueDate={invoice?.paymentDueDate}
          currencyName={invoice?.currency?.name}
        />
      </>
    } />
  )
};

export default InvoicePay
